import { Row, Col, theme } from 'antd';
import { useNavigate } from 'react-router-dom';
import { KpiCard } from './KpiCard';

interface EquipmentStatistics {
  total: number;
  active: number;
  highRisk: number;
  maintenanceRequired: number;
}

interface KpiSummaryCardsProps {
  statistics?: EquipmentStatistics;
  loading?: boolean;
  gutter?: [number, number];
}

export function KpiSummaryCards({ statistics, loading, gutter = [16, 16] }: KpiSummaryCardsProps) {
  const navigate = useNavigate();
  const { token } = theme.useToken();

  const total = statistics?.total ?? 0;
  const active = statistics?.active ?? 0;
  const maintenanceRequired = statistics?.maintenanceRequired ?? 0;

  // 稼働率の計算
  const operationalRate = total > 0 ? Math.round((active / total) * 100) : 0;

  // メンテナンス達成率の計算（健全度30%以上の設備の割合 = 劣化率70%未満）
  const maintenanceRate =
    total > 0 ? Math.round(((total - maintenanceRequired) / total) * 100) : 0;

  return (
    <Row gutter={gutter}>
      <Col xs={24} sm={12} lg={6}>
        <KpiCard
          title="総設備数"
          value={total}
          suffix="台"
          color={token.colorInfo}
          onClick={() => navigate('/app/equipments')}
          loading={loading}
        />
      </Col>
      <Col xs={24} sm={12} lg={6}>
        <KpiCard
          title="稼働率"
          value={operationalRate}
          suffix="%"
          color={token.colorSuccess}
          onClick={() => navigate('/app/equipments')}
          loading={loading}
        />
      </Col>
      <Col xs={24} sm={12} lg={6}>
        <KpiCard
          title="メンテナンス達成率"
          value={maintenanceRate}
          suffix="%"
          color={token.colorInfo}
          onClick={() => navigate('/app/deterioration')}
          loading={loading}
        />
      </Col>
      <Col xs={24} sm={12} lg={6}>
        <KpiCard
          title="危険水域の設備"
          value={maintenanceRequired}
          suffix="台"
          color={token.colorError}
          onClick={() =>
            navigate('/app/deterioration', { state: { healthIndex: '70below' } })
          }
          loading={loading}
        />
      </Col>
    </Row>
  );
}
